import { render } from "./TransactionPage.vue?vue&type=template&id=86db9cf2&scoped=true"
import script from "./TransactionPage.vue?vue&type=script&lang=js"
export * from "./TransactionPage.vue?vue&type=script&lang=js"

import "./TransactionPage.vue?vue&type=style&index=0&id=86db9cf2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86db9cf2"]])

export default __exports__